module.exports = __webpack_public_path__ + "static/media/RasikaSingh.f6223e98.png";